import React from 'react'

export function ArrowUp() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.29308 10.7068C3.48091 10.8944 3.73549 10.9997 4.00093 10.9997C4.26636 10.9997 4.52095 10.8944 4.70878 10.7068L8.00598 7.41381L11.3031 10.7068C11.4921 10.8889 11.7449 10.9896 12.0073 10.9873C12.2697 10.9851 12.5208 10.88 12.7066 10.6946C12.8922 10.5093 12.9975 10.2585 12.9998 9.99621C13.002 9.73395 12.9011 9.48131 12.7188 9.29281L8.71378 5.29281C8.52592 5.10531 8.27134 5 8.00593 5C7.74051 5 7.48593 5.10531 7.29808 5.29281L3.29308 9.29281C3.20017 9.38562 3.12646 9.49583 3.07617 9.61714C3.02588 9.73845 3 9.86849 3 9.99981C3 10.1311 3.02588 10.2612 3.07617 10.3825C3.12646 10.5038 3.20017 10.614 3.29308 10.7068Z"
        fill="currentColor"
      />
    </svg>
  )
}
